import { redirect, RouteObject } from 'react-router';

export const supportRoutes: RouteObject[] = [
	{
		path: 'support',
		lazy: async () => {
			const { default: Component } = await import('@/features/support/pages/SupportPage');
			return { Component };
		},
		children: [
			{
				index: true,
				loader: () => redirect('tutorials'),
			},
			{
				path: 'tutorials',
				lazy: async () => {
					const { default: Component } = await import(
						'@/features/support/tutorials/pages/TutorialsPage'
					);
					return { Component };
				},
			},
			{
				path: 'faqs',
				lazy: async () => {
					const { default: Component } = await import('@/features/support/pages/FAQPage');
					return { Component };
				},
			},
		],
	},
];
